module.exports = __webpack_public_path__ + "img/create-your-own.afa694be.svg";